//export const API_URL="http://192.168.1.65:8081";
//export const API_URL="http://localhost/servicosback/";
export const API_URL="http://148.228.103.214/servicosback/";
//export const API_URL="http://vinculacion.buap.mx/serviciosBack/";
export const API_IMAGE = "http://148.228.103.214/servicosback/public/consultores/";
export const TOKEN='token';
export const CART = "cart";
export const SEARCH_HISTORY = "search-history";